import { render, staticRenderFns } from "./productDetailJoin.vue?vue&type=template&id=79106702&scoped=true&"
import script from "./productDetailJoin.vue?vue&type=script&lang=js&"
export * from "./productDetailJoin.vue?vue&type=script&lang=js&"
import style0 from "./productDetailJoin.vue?vue&type=style&index=0&id=79106702&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79106702",
  null
  
)

export default component.exports